module.exports = __webpack_public_path__ + "static/img/アセット 9@2x.a4ea5b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/アセット 9@2x.png
// module id = ZC5V
// module chunks = 1